import { TrackJS } from 'trackjs'
import { pathOr } from 'ramda'

import { removeTrackJsNoise } from 'utils/trackjs'

/**
 * This function will load/install any 3rd party scripts that we need when the
 * app mounts.
 *
 * Not sure why they need to be mounted on load vs just being included in the
 * index.html, but that's how it's done and I don't want to change
 * functionality.
 */
export const handle3rdPartyScripts = () => {
  if (!TrackJS.isInstalled()) {
    TrackJS.install({
      token: '35cfe2140de445b3acc3d7306a85c2a9',
      application: 'sidecar-app',
      // this is so we don't track non prod errors the code runs in multiple
      // environments and we don't want to add noise to the prod errors
      onError: payload => removeTrackJsNoise(payload.url),
    })
  }

  // changes to FB and Apple iOS 14 privacy updates necessitate
  // the need to add dynamic meta tag depending on the subdomain.
  // Make sure to only do this once.
  if (!document.getElementsByName('facebook-domain-verification').length) {
    let metaTag = document.createElement('meta')
    metaTag.name = 'facebook-domain-verification'
    metaTag.content = pathOr(
      'app.sidecarhealth.com',
      ['location', 'hostname'],
      window,
    ).includes('insurance')
      ? '61onrskj9yd5yie7mtrzh7px8hwzi9'
      : 'ufk6klvql9e7ac5kivzzk6hsxzg5kn'
    document.head.appendChild(metaTag)
  }
}
